import { de } from './de';
import { en } from './en';
import { dataProtectionDe, legalNoticeDe } from './legal.de';
import { dataProtectionEn, legalNoticeEn } from './legal.en';
import type { LandingContent, LegalPageContent, Locale } from './types';

export const landingContent: Record<Locale, LandingContent> = {
  en,
  de,
};

export const legalNoticeContent: Record<Locale, LegalPageContent> = {
  en: legalNoticeEn,
  de: legalNoticeDe,
};

export const dataProtectionContent: Record<Locale, LegalPageContent> = {
  en: dataProtectionEn,
  de: dataProtectionDe,
};

export type { LandingContent, LegalPageContent, Locale };
